export default {
  methods: {
    handleRaceApiError(error, context) {
      let message = 'Произошла ошибка'

      if (error.response && error.response.status === 409) {
        message = (error.response.data && error.response.data.message)
          ? error.response.data.message
          : 'Анализ уже выполняется, повторите позже'
        const title = context ? context : 'Занято'
        if (this.$root && this.$root.$bvToast) {
          this.$root.$bvToast.toast(message, {
            title,
            variant: 'warning',
            solid: true,
            autoHideDelay: 5000,
          })
        }
        console.warn('[RaceAnalyzer] ' + context + ':', error)
        return
      }

      // Vue 2 compatible - no optional chaining
      if (error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message
      } else if (error.message) {
        message = error.message
      }
      
      const title = context ? 'Ошибка: ' + context : 'Ошибка'
      
      if (this.$root && this.$root.$bvToast) {
        this.$root.$bvToast.toast(message, {
          title: title,
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        })
      }
      
      console.error('[RaceAnalyzer] ' + context + ':', error)
    },
    
    showSuccessToast(message, title) {
      if (this.$root && this.$root.$bvToast) {
        this.$root.$bvToast.toast(message, {
          title: title || 'Успешно',
          variant: 'success',
          solid: true,
          autoHideDelay: 3000,
        })
      }
    },

    showInfoToast(message, title) {
      if (this.$root && this.$root.$bvToast) {
        this.$root.$bvToast.toast(message, {
          title: title || 'Информация',
          variant: 'info',
          solid: true,
          autoHideDelay: 3000,
        })
      }
    },

    showErrorToast(message, title) {
      if (this.$root && this.$root.$bvToast) {
        this.$root.$bvToast.toast(message, {
          title: title || 'Ошибка',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        })
      }
    },
  },
}

